<!-- 经销商信-->
<template>
    <div>
        <div class="card">
            <div class="title">{{ newFormData.name }}</div>
        </div>
        <div class="card mb0">
            <Menu
                mode="horizontal"
                :active-name="name_id"
                @on-select="selectName"
            >
                <MenuItem name="1" class="head-text">内容设置</MenuItem>
                <MenuItem name="2" class="head-text">边距设置</MenuItem>
            </Menu>
            <div class="mt24 mb24">
                <Form
                    v-if="name_id == 1"
                    :model="newFormData"
                    label-position="right"
                    :label-width="100"
                >
                    <div class="form-title">标题设置</div>
                    <FormItem label="标题样式">
                        <RadioGroup v-model="newFormData.content.style_value">
                            <Radio class="mr24" label="1">样式一</Radio>
                            <Radio class="mr24" label="2">样式二</Radio>
                        </RadioGroup>
                    </FormItem>
                    <FormItem
                        v-if="newFormData.content.style_value == 1"
                        label="装饰颜色"
                    >
                        <ColorPicker v-model="newFormData.content.dec_color" />
                    </FormItem>
                    <FormItem
                        v-if="newFormData.content.style_value == 2"
                        label="标题位置"
                    >
                        <RadioGroup
                            v-model="newFormData.content.position"
                            type="button"
                        >
                            <Radio label="left"><Icon type="md-menu" /></Radio>
                            <Radio label="center"
                                ><Icon type="md-funnel"
                            /></Radio>
                            <Radio label="right"><Icon type="md-menu" /></Radio>
                        </RadioGroup>
                    </FormItem>
                    <FormItem label="文字大小">
                        <Input
                            v-model="newFormData.content.title_size"
                            placeholder="请输入文字大小"
                            ><span slot="append">PX</span></Input
                        >
                    </FormItem>
                    <FormItem label="标题颜色"
                        ><ColorPicker v-model="newFormData.content.title_color"
                    /></FormItem>
                    <FormItem label="分割线颜色"
                        ><ColorPicker
                            v-model="newFormData.content.title_border_color"
                    /></FormItem>
                    <FormItem label="标题背景"
                        ><ColorPicker v-model="newFormData.content.title_bc"
                    /></FormItem>
                    <div class="form-title">经销商信息</div>
                    <FormItem label="信息显示">
                        <CheckboxGroup
                            v-model="newFormData.content.type"
                            @on-change="typeChange"
                        >
                            <Checkbox label="授权编号"></Checkbox>
                            <Checkbox label="手机号码"></Checkbox>
                            <Checkbox label="负责区域"></Checkbox>
                        </CheckboxGroup>
                    </FormItem>
                    <FormItem label="文字大小">
                        <Input
                            v-model="newFormData.content.size"
                            placeholder="请输入文字大小"
                            ><span slot="append">PX</span></Input
                        >
                    </FormItem>
                    <FormItem label="标题颜色"
                        ><ColorPicker v-model="newFormData.content.text_color"
                    /></FormItem>
                    <FormItem label="内容颜色"
                        ><ColorPicker v-model="newFormData.content.txt_color"
                    /></FormItem>
                    <div class="form-title">背景设置</div>
                    <FormItem label="背景颜色"
                        ><ColorPicker v-model="newFormData.content.bg_color"
                    /></FormItem>
                    <FormItem label="背景图">
                        <i-switch
                            v-model="newFormData.content.bg_value"
                            size="large"
                            true-color="var(--primary-color) "
                            :true-value="1"
                            :false-value="0"
                            @on-change="changeBgValue"
                        >
                            <span slot="open">开启</span>
                            <span slot="close">关闭</span>
                        </i-switch>
                    </FormItem>
                    <FormItem
                        v-if="newFormData.content.bg_value"
                        label="上传背景"
                    >
                        <div class="bg-upload" @click="openModal('bg_img')">
                            <img
                                class="bg-img"
                                v-if="newFormData.content.bg_img.picview"
                                :src="newFormData.content.bg_img.picview"
                            />
                            <Icon v-else type="md-add" size="30" color="#ccc" />
                        </div>
                    </FormItem>
                </Form>
                <div v-if="name_id == 2">
                    <Form
                        :model="newFormData"
                        label-position="right"
                        :label-width="80"
                    >
                        <div class="form-title">外间距</div>
                        <FormItem label="上下间距"
                            ><Slider
                                v-if="newFormData.content.marginData"
                                class="w300"
                                show-input
                                v-model="newFormData.content.marginData.top"
                            ></Slider
                        ></FormItem>
                        <FormItem label="左右间距"
                            ><Slider
                                v-if="newFormData.content.marginData"
                                class="w300"
                                show-input
                                v-model="newFormData.content.marginData.left"
                            ></Slider
                        ></FormItem>
                        <div class="form-title">内间距</div>
                        <FormItem label="上下间距"
                            ><Slider
                                v-if="newFormData.content.paddingData"
                                class="w300"
                                show-input
                                v-model="newFormData.content.paddingData.top"
                            ></Slider
                        ></FormItem>
                        <FormItem label="左右间距"
                            ><Slider
                                v-if="newFormData.content.paddingData"
                                class="w300"
                                show-input
                                v-model="newFormData.content.paddingData.left"
                            ></Slider
                        ></FormItem>
                        <div class="form-title">圆角设置</div>
                        <FormItem label="上圆角"
                            ><Slider
                                v-if="newFormData.content.radiusData"
                                class="w300"
                                show-input
                                v-model="newFormData.content.radiusData.top"
                            ></Slider
                        ></FormItem>
                        <FormItem label="下圆角"
                            ><Slider
                                v-if="newFormData.content.radiusData"
                                class="w300"
                                show-input
                                v-model="newFormData.content.radiusData.bottom"
                            ></Slider
                        ></FormItem>
                    </Form>
                </div>
            </div>
        </div>
        <pictureLibrary
            v-if="switch_modal"
            :switch_modal.sync="switch_modal"
            :select="select"
            :select_type="select_type"
            @change="costPlannedAmountChange"
        ></pictureLibrary>
    </div>
</template>

<script>
import pictureLibrary from "@/components/pictureLibrary/pictureLibrary.vue";
export default {
    components: {
        pictureLibrary,
    },
    props: {
        newFormData: {
            type: Object,
            default: {},
        },
    },
    data() {
        return {
            select: 1,
            select_type: "image",
            switch_modal: false,
            name_id: "1",
        };
    },
    mounted() {},
    methods: {
        // 事件处理函数
        async costPlannedAmountChange(param1, param2) {
            for (var i = 0; i < param1.length; i++) {
                this.newFormData.content.bg_img.picview = param1[i];
            }
            for (var i = 0; i < param2.length; i++) {
                this.newFormData.content.bg_img.value = param2[i];
            }
            this.$Message.destroy();
        },
        openModal(index) {
            this.switch_modal = true;
        },
        selectName(name) {
            this.name_id = name;
        },
        typeChange(e) {
            console.log("eee", e);
        },
        changeBgValue(e) {
            this.newFormData.content.bg_value = e;
        },
    },
};
</script>

<style scoped>
.card {
    padding: 24px;
    margin-bottom: 12px;
    width: 100%;
    background: #ffffff;
    box-shadow: 0px 0px 4px 0px rgba(82, 102, 136, 0.1);
    border-radius: 5px;
}
.title {
    display: flex;
    align-items: center;
    font-weight: 500;
    font-size: 22px;
    color: #484e66;
}
.title::before {
    content: " ";
    display: block;
    width: 4px;
    height: 26px;
    margin-right: 12px;
    background: var(--primary-color);
}
.form-title {
    margin: 24px 0;
    font-weight: bold;
    font-size: 15px;
    color: #484e66;
}
/* RadioGroup */
::v-deep .ivu-radio-group-button .ivu-radio-wrapper-checked {
    background: #fff;
    border-color: var(--primary-color);
    color: var(--primary-color);
    box-shadow: -1px 0 0 0 var(--primary-color);
}
::v-deep .ivu-radio-group-button :hover {
    color: var(--primary-color);
}
.bg-upload {
    width: 80px;
    height: 80px;
    background: #ffffff;
    border: 1px solid #ccc;
    border-radius: 4px;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
}
.bg-img {
    width: 100%;
    height: 100%;
    border-radius: 4px;
}
::v-deep .ivu-slider-bar {
    background-color: var(--primary-color);
}
::v-deep .ivu-slider-button {
    border: 2px solid var(--primary-color);
}
</style>